import React, { useEffect } from "react";
import Link from "next/link";
import sal from "sal.js";
import { useUserContext } from "@/context/UserContext";


const PricingTwo = ({ parentClass, childClass, isHeading, gap, manageAccountUrl, isLoading }) => {

  const { userLoggedIn, userInfo } = useUserContext();

  const pricingData = [
  {
    title: "Juree Basic",
    price: 0,
    subTitle: "",
    isActive: userLoggedIn,
    unsignedInText: "Activated",
    unactiveText: "Sign In",
    activeText: "Activated",
    unsignedInLink: "/",
    unactiveLink: "/",
    activeLink: "/",
    subItem: [
      { text: "Document Research", isMinus: true },
      { text: "Application Support", isMinus: true },
      { text: "Exclusive Offers", isMinus: true },
      { text: "Contribute to Forum", isMinus: false },
      { text: "Access to Forum", isMinus: false }
    ]
  },
  {
    title: "Juree Pro",
    price: 9.99,
    subTitle: "Per Month",
    isActive: userInfo.is_premium_member || false,
    unsignedInText: "Sign In To Upgrade",
    unactiveText: "Try Free for 7 Days",
    activeText: "Manage",
    unsignedInLink: "/SignIn",
    unactiveLink: "/plans-billing/checkout",
    activeLink: manageAccountUrl,
    subItem: [
      { text: "Document Research", isMinus: false },
      { text: "Application Support", isMinus: false },
      { text: "Exclusive Offers", isMinus: false },
      { text: "Contribute to Forum", isMinus: false },
      { text: "Access to Forum", isMinus: false }
    ]
  },
];
  useEffect(() => {
    sal();
    const cards = document.querySelectorAll(".bg-flashlight");
    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;
        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);

  return (
    <div className="main-content">
      <div className={`jureeltd-pricing-area ${gap ? "jureeltd-section-gap jureeltd-section-gapTop-big" : ""}`}>
        <div className="container">
          <div className="wrapper">
            {isHeading && (
              <div className="section-title text-center" data-sal="slide-up" data-sal-duration="400" data-sal-delay="150">
                <h4 className="subtitle"><span className="theme-gradient">Pricing</span></h4>
                <h2 className="title w-600 mb--20">Commence Content Journey with AI</h2>
                <p className="description b1">Collaborate with AI to generate content that resonates.</p>
              </div>
            )}

            <div className={childClass}>
              <div className="row row--15 mt_dec--30">
                {pricingData.map((data, index) => (
                  <div key={index} className={`${parentClass} mt--30`}>
                    <div className={`jureeltd-pricing style-juree ${data.price > 50 ? "active" : ""}`}>
                      <div className="pricing-table-inner bg-flashlight">
                        <div className="pricing-header">
                          <h4 className="title">{data.title}</h4>
                          <div className="pricing">
                            <div className="price-wrapper">
                              {data.price === 0 ? (
                                <span className="price">Free</span>
                              ) : (
                                <>
                                  <span className="currency">£</span>
                                  <span className="price">{data.price}</span>
                                </>
                              )}
                            </div>
                            <span className="subtitle">{data.subTitle}</span>
                          </div>
                        </div>
                        <div className="separator-animated animated-true mt--30 mb--30"></div>
                        <div className="pricing-body">
                          <ul className="list-style--1">
                            {data.subItem.map((item, itemIndex) => (
                              <li key={itemIndex}>
                                <i className={`feather-${item.isMinus ? "minus" : "check"}-circle pe-2`}></i>
                                <span style={{ textDecoration: item.isMinus ? "line-through" : "none" }}>
                                  {item.text}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="pricing-footer">
                          {userLoggedIn ? (
                            data.isActive ? (
                              <Link className="btn-default btn-border" href={data.activeLink}>
                                {data.activeText}
                              </Link>
                            ) : (
                              <Link className={`btn-default ${data.title === "Business" ? "btn-border" : ""}`} href={data.unactiveLink}>
                                {data.unactiveText}
                              </Link>
                            )
                          ) : (
                            <Link className={`btn-default ${data.title === "Business" ? "btn-border" : ""}`} href={data.unsignedInLink}>
                              {data.unsignedInText}
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTwo;
